// src/components/LoginButton.js
import React, { useState } from "react";
import { Tooltip, IconButton } from "@chakra-ui/react";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebaseConfig";
// Importer to ikoner fra react-icons (bytt til det du liker best)
//import { RiLoginCircleLine, RiLoginCircleFill } from "react-icons/ri";
import { IoMdLogIn } from "react-icons/io";
import { BiLogInCircle } from "react-icons/bi";

const LoginButton = () => {
  const [hovered, setHovered] = useState(false);

  const handleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <Tooltip label="Logg inn" aria-label="Logg inn tooltip" openDelay={300}>
    <IconButton
      aria-label="Logg inn"
      variant="ghost"
      fontSize="24px"
      icon={hovered ? <IoMdLogIn /> : <BiLogInCircle />}
      onClick={handleLogin}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      _hover={{
        bg: "inherit",
      }}
      _active={{
        bg: "inherit",
      }}
      _focus={{
        boxShadow: "none",
      }}
    />
  </Tooltip>
  );
};

export default LoginButton;